import { AdminLayoutComponent } from '../../../../admin/admin-layout/admin-layout.component';
import { AdminGuard } from 'Src/ng2/routing/guards/admin-guard/admin-guard';
import { SessionStorageEntityIdResolver } from '../../../../routing/resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const adminRoute = {
  path: 'admin',
  url: '/admin',
  canActivate: [AdminGuard],
  component: AdminLayoutComponent,
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () =>
    import('../../../../admin/admin-routing.module').then(m => m.AdminRoutingModule),
};
